// Built-in import
import * as React from "react"
// External import
import { Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next";


interface IShortDescription {
    title?: string
    value: number | string
}
const ShortDescription: React.FunctionComponent<IShortDescription> = ({ value, title }) => {

    const { t } = useTranslation(["common"]);

    return (
        <Stack
            direction={!title ? "column" : "row"}
            justifyContent={!title ? "center" : "space-between"}
            alignItems={!title ? "center" : null}
            flexWrap="wrap"
            px={1}
            sx={{
                [`& a`]: {
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    color: (t) => t.palette.primary.main,
                    ":hover": {
                        textDecoration: "underline !important",
                    },
                },
            }}
        >
            {title && <Typography variant="smallMedium" color="text.primary">
                {/* {t(`common:${title}`)}: */}
                {title}:
            </Typography>

            }
            <Typography variant="smallMedium" color="grey.400" textAlign="center">
                {value}
            </Typography>
        </Stack>
    )
}

export default ShortDescription
